import React from 'react';
import type { Category } from '../../../common/models/categories/category';
import type { Area } from '../../models/companies/areas/area';
import type { Feature } from '../../models/companies/features/feature';
import type { EcfStage } from '../../models/companies/ecf_stages/ecfStage';
import type { CompanyProperty } from '../../models/companies/company';

interface Props {
  name: string;
  items: readonly (Category | Area | Feature | EcfStage | CompanyProperty)[];
  activeItemId: number | null;
  isOpen: boolean;
  className: string;
  onClick: () => void;
  onClickItem: (id: number | null) => void;
}

export function ConditionList({
  name,
  items,
  activeItemId,
  isOpen,
  className,
  onClick,
  onClickItem,
}: Props) {
  return (
    <div className={`yama-list-group ${className} mb-3`}>
      <button
        type="button"
        className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
        onClick={onClick}
      >
        {name}
        <i className="fas fa-angle-down float-right" />
      </button>
      {isOpen &&
        items.map(item => (
          <button
            key={item.id}
            type="button"
            className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${
              activeItemId === item.id ? 'active' : ''
            }`}
            onClick={(): void =>
              onClickItem(item.id === activeItemId ? null : item.id)
            }
          >
            {item.name}
            <i className="fas fa-angle-right" />
          </button>
        ))}
    </div>
  );
}
